"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const fa_1 = require("react-icons/fa");
const Card_1 = __importDefault(require("@/components/Card"));
const Button_1 = __importDefault(require("@/components/Button"));
const IconButton_1 = __importDefault(require("@/components/IconButton"));
const style_1 = require("./style");
const ProductList_1 = __importDefault(require("./ProductList"));
const SystemCardView = ({ systemName, productsList, onNavigateToComponentsAssociation, onOpenEditionModal, }) => {
    return (react_1.default.createElement(Card_1.default, { sx: style_1.cardStyles },
        react_1.default.createElement(style_1.ContentWrapper, null,
            react_1.default.createElement(style_1.TitleSection, null,
                react_1.default.createElement(Typography_1.default, { variant: "h3" }, systemName),
                react_1.default.createElement(IconButton_1.default, { icon: fa_1.FaEdit, onClick: onOpenEditionModal, style: style_1.iconStyle, disableRipple: true })),
            react_1.default.createElement(style_1.ProductListContainer, null,
                react_1.default.createElement(Typography_1.default, { variant: "h6", sx: {
                        color: "#2886BF",
                        textTransform: "uppercase",
                        fontWeight: "bold",
                    } }, "Main Products"),
                " ",
                react_1.default.createElement(ProductList_1.default, { productsList: productsList })),
            react_1.default.createElement(Button_1.default, { variant: "text", onClick: onNavigateToComponentsAssociation, rightLabel: fa_1.FaAngleRight, label: productsList?.length === 0 ? "Add Components" : "View all" }))));
};
exports.default = SystemCardView;
